import React, { useState } from "react";
import { Form, Button, Row, Col, Dropdown, FormControl } from "react-bootstrap";
import "./Filtri.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store";
import { urlcantiere } from "../lib/api.ts";
import { allGet } from "../Redux/Actions.tsx";

interface FormFiltriCantieriProps {
  onClose: () => void;
  setTable: (data: any[]) => void;
  // Riceviamo lo stato e la funzione di update dal padre
  filtroCantiere: {
    nome: string;
    citta: string;
    cap: string;
    dataInizioStart: string;
    dataInizioEnd: string;
    dataFineStart: string;
    dataFineEnd: string;
  };
  setFiltroCantiere: React.Dispatch<
    React.SetStateAction<{
      nome: string;
      citta: string;
      cap: string;
      dataInizioStart: string;
      dataInizioEnd: string;
      dataFineStart: string;
      dataFineEnd: string;
    }>
  >;
}

const FormFiltriCantieri: React.FC<FormFiltriCantieriProps> = ({
  onClose,
  setTable,
  filtroCantiere,
  setFiltroCantiere,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.login);
  const { cantieri } = useSelector((state: RootState) => state.cantieri);
  const contratti = useSelector(
    (state: RootState) => state.contratti.contratti
  );

  // Stato locale per filtrare la lista "nome" nei dropdown
  const [nomeSearchText, setNomeSearchText] = useState("");

  const handleChange = (name: string, value: string) => {
    setFiltroCantiere((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    let url = `${urlcantiere}/filter?`;

    if (filtroCantiere.nome) url += `nome=${filtroCantiere.nome}`;
    if (filtroCantiere.citta) url += `&citta=${filtroCantiere.citta}`;
    if (filtroCantiere.cap) url += `&cap=${filtroCantiere.cap}`;
    if (filtroCantiere.dataInizioStart)
      url += `&dataInizioStart=${filtroCantiere.dataInizioStart}`;
    if (filtroCantiere.dataInizioEnd)
      url += `&dataInizioEnd=${filtroCantiere.dataInizioEnd}`;
    if (filtroCantiere.dataFineStart)
      url += `&dataFineStart=${filtroCantiere.dataFineStart}`;
    if (filtroCantiere.dataFineEnd)
      url += `&dataFineEnd=${filtroCantiere.dataFineEnd}`;

    dispatch(allGet(url, token)).then((filteredData) => {
      if (filteredData) {
        const cantieriConDati = filteredData.map((cantiere: any) => ({
          ...cantiere,
          codiceContratto:
            contratti.find(
              (contratto) => contratto.id === cantiere.contrattoQuadro
            )?.codice || "N/A",
          nomeReferente: (() => {
            const cContratto = contratti.find(
              (cc) => cc.id === cantiere.contrattoQuadro
            );
            if (cContratto?.referenti?.[0]) {
              return `${cContratto.referenti[0].nome} ${cContratto.referenti[0].cognome}`;
            }
            return "Nessun referente";
          })(),
          subappalto: cantiere.subappalto === "true" ? "Sì" : "No",
          statoBadge: cantiere.stato?.toLowerCase() || "default",
          importo: `${cantiere.importo || 0} €`,
        }));

        setTable(cantieriConDati);
        onClose();
      } else {
        console.error("Errore nel caricamento dei filtri");
      }
    });
  };

  const handleReset = () => {
    setFiltroCantiere({
      nome: "",
      citta: "",
      cap: "",
      dataInizioStart: "",
      dataInizioEnd: "",
      dataFineStart: "",
      dataFineEnd: "",
    });

    dispatch(allGet(urlcantiere, token)).then((data) => {
      if (data) {
        const cantieriConDati = data.map((cantiere: any) => ({
          ...cantiere,
          codiceContratto:
            contratti.find(
              (contratto) => contratto.id === cantiere.contrattoQuadro
            )?.codice || "N/A",
          nomeReferente: (() => {
            const cContratto = contratti.find(
              (cc) => cc.id === cantiere.contrattoQuadro
            );
            if (cContratto?.referenti?.[0]) {
              return `${cContratto.referenti[0].nome} ${cContratto.referenti[0].cognome}`;
            }
            return "Nessun referente";
          })(),
          subappalto: cantiere.subappalto === "true" ? "Sì" : "No",
          statoBadge: cantiere.stato?.toLowerCase() || "default",
          importo: `${cantiere.importo || 0} €`,
        }));

        setTable(cantieriConDati);
      }
    });
  };

  return (
    <div className="form-filtri-cantieri">
      {/* NOME come Dropdown con ricerca */}
      <Form.Group className="mb-3">
        <Form.Label htmlFor="nome">Nome</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 input-crea-edit p-0 h-2r"
            id="dropdownNome"
          >
            {filtroCantiere.nome ? filtroCantiere.nome : "Seleziona Nome"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per Nome"
              onChange={(e) => setNomeSearchText(e.target.value)}
              value={nomeSearchText}
            />
            <Dropdown.Divider />

            {cantieri
              .filter((c) =>
                c.nome?.toLowerCase().includes(nomeSearchText.toLowerCase())
              )
              .map((c, idx: number) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() => handleChange("nome", c.nome)}
                >
                  {c.nome}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* Citta */}
      <Form.Group className="mb-3">
        <Form.Label htmlFor="citta">Città</Form.Label>
        <Form.Control
          type="text"
          className="w-100"
          id="citta"
          value={filtroCantiere.citta}
          onChange={(e) => handleChange("citta", e.target.value)}
          placeholder="Inserisci la città"
        />
      </Form.Group>

      {/* CAP */}
      <Form.Group className="mb-3">
        <Form.Label htmlFor="cap">CAP</Form.Label>
        <Form.Control
          type="text"
          id="cap"
          className="w-100"
          value={filtroCantiere.cap}
          onChange={(e) => handleChange("cap", e.target.value)}
          placeholder="Inserisci il CAP"
        />
      </Form.Group>

      {/* Data Inizio */}
      <Form.Group className="mb-3">
        <Form.Label>Data Inizio</Form.Label>
        <Row>
          <Col>
            <Form.Control
              type="date"
              value={filtroCantiere.dataInizioStart}
              onChange={(e) => handleChange("dataInizioStart", e.target.value)}
              placeholder="Da"
            />
          </Col>
          <Col>
            <Form.Control
              type="date"
              value={filtroCantiere.dataInizioEnd}
              onChange={(e) => handleChange("dataInizioEnd", e.target.value)}
              placeholder="A"
            />
          </Col>
        </Row>
      </Form.Group>

      {/* Data Fine */}
      <Form.Group className="mb-3">
        <Form.Label>Data Fine</Form.Label>
        <Row>
          <Col>
            <Form.Control
              type="date"
              value={filtroCantiere.dataFineStart}
              onChange={(e) => handleChange("dataFineStart", e.target.value)}
              placeholder="Da"
            />
          </Col>
          <Col>
            <Form.Control
              type="date"
              value={filtroCantiere.dataFineEnd}
              onChange={(e) => handleChange("dataFineEnd", e.target.value)}
              placeholder="A"
            />
          </Col>
        </Row>
      </Form.Group>

      {/* Pulsanti */}
      <Row>
        <Col className="text-end">
          <Button variant="secondary" onClick={handleReset}>
            Cancella Filtri
          </Button>
          <Button className="button ms-2" onClick={handleSubmit}>
            Applica Filtri
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default FormFiltriCantieri;
